// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import localeEN from 'element-ui/lib/locale/lang/en'
import localeCN from 'element-ui/lib/locale/lang/zh-CN'
import * as echarts from 'echarts';
import '../static/css/main.css'; /*引入公共样式*/
import '../static/css/iconfont.css';
import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies'
//import service from './service/HttpService';
import {openLoading} from './utils/cover'
import VueI18n from 'vue-i18n'
import $ from 'jquery'
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    'zh': require('./components/language/zh'),
    'en': require('./components/language/en')
  }
});

Vue.use(ElementUI,{
  locale:i18n.locale=='zh'?localeCN:localeEN
})
Vue.use(VueResource);
Vue.use(VueCookies);
Vue.config.productionTip = false
let area = "CN" // 使用场景，CN中国，SGP新加坡
// 判断remoteUrl是哪
let prefix = "https://jd.lhcoffeetime.com"
if(area === "CN"){
  prefix = 'https://jd.lhcoffeetime.com'
  //prefix = "https://localhost:5001"
}else if(area === 'SGP'){
  prefix = 'https://atom.lhcoffeetime.com'
}
Vue.prototype.$prefix = prefix;
Vue.prototype.$echarts = echarts;
//登录账户信息，这里设置成引用类型的意义是防止数据被vue重置
Vue.prototype.$account = {data:null};

Vue.prototype.openLoading = openLoading


import service from './service/HttpService';

Vue.prototype.$httpservice = service;

//判断当前用户是否登录
let token = Vue.$cookies.get("token");
if(token){
  let tokenStr = "Bearer "+token;
  $.ajax(
    {
      async: false,
      type: "Get",
      url: service.host+"api/account/currentaccount",
      headers:{
        Authorization:tokenStr
      },
      success: function (data) {

          if(data.code=="200"){
            Vue.prototype.$account.data = data.data;

          }else{
            this.$message({
              message: data.msg,
              type: 'danger'
             });
          }
      },
      dataType:"json"
    }
  );
}

// 防重复点击(指令实现)
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})
router.beforeEach((to,from,next)=>{
  // 判断是否需要强制更换密码
  let isNeedChangePassword = sessionStorage.getItem('isNeedChangePassword')
  console.log("是否需要改密码",isNeedChangePassword)
  if(isNeedChangePassword === "y"){
    if(to.path === '/home/Person'){
      next()
    }else if(to.path === '/login' || to.path === '/loginqek' || to.path === '/loginXl'){
      next()
    }else{
      next('/home/Person')
    }
  }else{
    next()
  }
  // 根据中英文，切换
  let lang = localStorage.getItem('languageSet')=='zh'?true:false
  if(lang){
    document.title = '智造管理系统'
  }else{
    document.title = 'iPilot management'
  }
  next()
})


new Vue({
  beforeCreate: function () {
    this.$httpservice.$account = this.$account;
  },
  el: '#app',
  router,i18n,
  components: { App },
  template: '<App/>'
})

import {modifyRequest} from "./utils/config";

modifyRequest(Vue)



// WEBPACK FOOTER //
// ./src/main.js